import PropTypes from 'prop-types'
import { useOutletContext } from 'react-router-dom'

import Table from '@/components/table/index.jsx'
import { columnsRenderersRD } from '@/pages/projects/list/projects-tables/r&d-table/columnsR&D.jsx'
import { tableHeight } from '@/utilities/helpers'

const RDTables = () => {
    const { props } = useOutletContext()

    const {
        rdData,
        tableColumns,
        openDialogDelete,
        openEditSidebar,
        goToDetails,
        goToCustomer,
    } = props

    return (
        <Table
            columns={tableColumns.rd}
            columnsRenderers={columnsRenderersRD(
                openDialogDelete,
                openEditSidebar,
                goToDetails,
                goToCustomer
            )}
            data={rdData}
            isPaginated
            bodyheight={tableHeight(rdData)}
        />
    )
}
export default RDTables

RDTables.propTypes = {
    rdData: PropTypes.array,
    tableColumns: PropTypes.object,
    openDialogDelete: PropTypes.func,
    openEditSidebar: PropTypes.func,
    goToDetails: PropTypes.func,
    goToCustomer: PropTypes.func,
}
